import type { CSSProperties, SVGProps } from 'react'
import classes from './icon.module.css'

export type KeyboardArrowDownProps = SVGProps<SVGSVGElement> & {
  className?: string
  style?: CSSProperties
}
export function KeyboardArrowDown(props: KeyboardArrowDownProps) {
  const { className, style, ...rest } = props

  const cls = `${classes.root} ${className || ''}`
  return (
    <svg
      aria-hidden="true"
      className={cls}
      focusable="false"
      viewBox="0 0 24 24"
      {...rest}
      data-testid="KeyboardArrowDownIcon"
      style={style}
    >
      <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
    </svg>
  )
}
